export function PageCardSkeleton() {
  return (
    <div className="tw-w-full tw-min-w-[538px] tw-min-h-[350px] tw-bg-search-grey/10 tw-animate-pulse"></div>
  )
};